export default __webpack_public_path__ + "static/media/pictogramUtilityWater64.0aadf3f1.svg";